<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.customerUserPO.headImg" v-if="info.customerUserPO && info.customerUserPO.headImg" :preview-src-list="[info.customerUserPO.headImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <div class="ml10">
          <div class="flexs">
            <span class="font16">{{info.customerUserPO.userName || info.customer.name}}</span>
            <i style="font-size: 13px;" :class="info.customerUserPO.userName==1?'el-icon-male':'el-icon-female'" :style="{'color':info.customerUserPO.userName==1?'#60B7DC':'#F59494'}" class="ml5"></i>
            <div class="font12 label-box ml5">{{info.customerLevel.name}}</div>
          </div>
          <div class="flexs mt5" v-if="info.customerTag && info.customerTag.length">
            <span class="font14 c-8F8E8E">业务标签：</span>
            <div v-for="item in info.customerTag" :key="item.id" class="font12 label-boxs ml5">{{item.name}}</div>
          </div>
          <div class="flexs mt5" v-if="info.customerJSTag && info.customerJSTag.length">
            <span class="font14 c-8F8E8E">技术标签：</span>
            <div v-for="item in info.customerJSTag" :key="item.id" class="font12 label-boxs ml5">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div>
        <el-descriptions title="" direction="vertical" :column="10" :colon="false">
          <el-descriptions-item label="客户ID" label-class-name="c-8F8E8E">{{info.customer.id}}</el-descriptions-item>
          <el-descriptions-item label="用友编码" label-class-name="c-8F8E8E">{{info.customer.code}}</el-descriptions-item>
          <el-descriptions-item label="电话" label-class-name="c-8F8E8E">{{info.customer.pho}}</el-descriptions-item>
          <el-descriptions-item label="客户来源" label-class-name="c-8F8E8E">{{info.customer.source}}</el-descriptions-item>
          <el-descriptions-item label="所在区域" label-class-name="c-8F8E8E" v-if="info.addr && info.addr.length" :span="2">{{info.addr[0].regionName}}{{info.addr[1].regionName}}{{info.addr[2].regionName}}</el-descriptions-item>
          <el-descriptions-item label="账号等级" label-class-name="c-8F8E8E">{{info.customer.mainId?'子账号':'主账号'}}</el-descriptions-item>
          <el-descriptions-item label="通商云ID" label-class-name="c-8F8E8E">{{info.customerUserPO.bizUserId}}</el-descriptions-item>
          <!-- <el-descriptions-item label="邀请业务员" label-class-name="c-8F8E8E">暂无字段</el-descriptions-item> -->
          <el-descriptions-item label="注册app时间" label-class-name="c-8F8E8E">{{info.customerUserPO.firstLoginTime}}</el-descriptions-item>
          <el-descriptions-item label="注册时身份" label-class-name="c-8F8E8E">{{info.firstLevelName}}</el-descriptions-item>
          <el-descriptions-item label="刷脸信息" label-class-name="c-8F8E8E">{{info.faceInfo && info.faceInfo.certificateStatus?'已认证':'未认证'}}</el-descriptions-item>
          <el-descriptions-item label="子账号" label-class-name="c-8F8E8E">{{info.subCount}}</el-descriptions-item>
          <el-descriptions-item label="绑定业务员" label-class-name="c-8F8E8E" :span="2">{{info.line.name}}</el-descriptions-item>
          <el-descriptions-item label="绑定技术老师" label-class-name="c-8F8E8E" :span="2">{{info.technicianInfo?info.technicianInfo.realName:''}}</el-descriptions-item>
          <el-descriptions-item label="账户状态" label-class-name="c-8F8E8E">{{info.customer.state?'启用':'禁用'}}</el-descriptions-item>
          <el-descriptions-item label="登录状态" label-class-name="c-8F8E8E">{{info.customerUserPO.entryInhibited?'禁用':'启用'}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <el-tabs v-model="activeName" @tab-click="" class="mt20">
        <el-tab-pane label="基础信息" name="1"></el-tab-pane>
        <el-tab-pane label="订单统计" name="2"></el-tab-pane>
        <el-tab-pane label="课程信息" name="3"></el-tab-pane>
        <el-tab-pane label="会议记录" name="4"></el-tab-pane>
        <!-- <el-tab-pane :label="`子账号(${list.length})`" name="5"></el-tab-pane> -->
        <el-tab-pane label="账户明细" name="6"></el-tab-pane>
        <el-tab-pane label="业务跟进" name="7"></el-tab-pane>
        <el-tab-pane label="技术跟进" name="8"></el-tab-pane>
        <el-tab-pane label="用户轨迹" name="9"></el-tab-pane>
      </el-tabs>
      <template v-if="activeName==1">
        <div class="flexs mt20">
          <div v-for="(item,index) in stepList" :key="index" class="relative step-box font14">
            <el-image :src="require(`@/assets/step${item.isActive?'_active':''}.png`)" v-if="!index" />
            <el-image :src="require(`@/assets/step2${item.isActive?'_active':''}.png`)" alt="" v-else-if="index==stepList.length-1" />
            <el-image :src="require(`@/assets/step1${item.isActive?'_active':''}.png`)" alt="" v-else />
            <div class="absolute w-100 h-100 flexs justify-center" :class="item.isActive?'c-fff':'c-8F8E8E'">
              {{item.label}}</div>
          </div>
        </div>
        <Title class="mt40">实名认证：<span :style="{'color': info.customerCertificates?'#0D862F':'#E73F3F'}">{{info.customerCertificates?'已认证':'未认证'}}</span>
        </Title>
        <el-descriptions title="" v-if="info.customerCertificates && info.customerCertificates.certificatesType==1">
          <el-descriptions-item label="认证类型">企业认证</el-descriptions-item>
          <el-descriptions-item label="门店类型">{{getCompanyTypeName(info.customerCertificates.companyType)}}</el-descriptions-item>
          <el-descriptions-item label="企业全称">{{info.customerCertificates.companyName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="所在地">{{info.customerCertificates.companyType}}</el-descriptions-item> -->
          <el-descriptions-item label="资质证件类型">{{info.customerCertificates.companyZiZhi==2?'医疗机构职业许可证':'营业执照'}}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码">{{info.customerCertificates.code}}</el-descriptions-item>
          <el-descriptions-item label="纳税人识别号">{{info.customerCertificates.taxpayerCode}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.customerCertificates.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="资质证件">
            <el-image style="width: 150px;" :src="info.customerCertificates.certificatesImg" :preview-src-list="[info.customerCertificates.certificatesImg]"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="" v-if="info.customerCertificates && info.customerCertificates.certificatesType==2">
          <el-descriptions-item label="认证类型">个人认证</el-descriptions-item>
          <el-descriptions-item label="姓名">{{info.customerCertificates.companyName}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{info.customerCertificates.code}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.customerCertificates.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="身份证">
            <el-image style="width: 150px;" :src="info.customerCertificates.certificatesImg.split(',')[0]" :preview-src-list="info.customerCertificates.certificatesImg.split(',')"></el-image>
            <el-image style="width: 150px;" class="ml10" :src="info.customerCertificates.certificatesImg.split(',')[1]" :preview-src-list="info.customerCertificates.certificatesImg.split(',')"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <!-- <Title class="mt20">分润比例</Title>
        <el-descriptions title="">
            <el-descriptions-item label="研修班">kooriookami</el-descriptions-item>
            <el-descriptions-item label="体验班">18100000000</el-descriptions-item>
        </el-descriptions> -->
        <Title class="mt20" v-if="!info.customer.mainId && info.contractList.length">合同信息</Title>
        <div v-if="!info.customer.mainId && info.contractList.length" class="font14" style="color: rgb(96, 98, 102);display: flex;">
          <div style="margin-right: 300px;">合同：{{info.contractList[0].contractName}}<a href="" class="ml10 c-main">下载</a></div>
          <div style="display: flex;" class="font14">历史合同：<div>
              <div v-for="item in contractList" class="mb10">{{item.contractName}}<a href="" class="ml10 c-main">下载</a></div>
            </div>
          </div>
        </div>
        <Title class="mt20">从属关系</Title>
        <el-descriptions title="">
          <el-descriptions-item label="技术线" :span="12">{{}}</el-descriptions-item>
          <el-descriptions-item label="业务线" :span="12">{{customerLine}}</el-descriptions-item>
          <el-descriptions-item label="城市公司" :span="12">{{info.cityCompany?info.cityCompany.cityCompanyName : ''}}</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20" v-if="info.customer.clevel!=8 && !info.customer.mainId">报名费用</Title>
        <div v-if="info.customer.clevel!=8 && !info.customer.mainId">
          <el-descriptions title="" v-for="item in info.registrationList" :key="item.id">
            <!-- <el-descriptions-item label="报名体验班方式">kooriookami</el-descriptions-item> -->
            <el-descriptions-item :label="`报名${item.levelId==7?'体验班':'研修班'}时间`">{{item.payTime}}</el-descriptions-item>
            <el-descriptions-item :label="`${item.levelId==7?'体验班':'研修班'}学费`">{{item.fee}}元</el-descriptions-item>
            <el-descriptions-item label="申请编号">{{item.num}}</el-descriptions-item>
            <el-descriptions-item label="申请时间">{{item.createdTime}}</el-descriptions-item>
            <el-descriptions-item label="提交人" v-if="item.createdUserPO">{{item.createdUserPO.realName}}【{{item.createdUserLevelName}}】</el-descriptions-item>
            <el-descriptions-item label="申请结果">{{item.state==1?'已通过':item.state==2?'未通过':'审核中'}}</el-descriptions-item>
            <el-descriptions-item :label="`${item.levelId==7?'体验班':'研修班'}付款凭证`" :span="12" v-if="item.payList">
              <el-image style="width: 180px;height: 120px;" :src="it.payImg" :preview-src-list="[it.payImg]" fit="cover" v-for="it in item.payList" :key="it.id" class="mr10"></el-image>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <Title class="mt20" v-if="!info.customer.mainId">其他信息</Title>
        <el-descriptions title="" v-if="!info.customer.mainId">
          <el-descriptions-item label="日均门诊量">{{info.customer.shopOutpatient}}</el-descriptions-item>
          <el-descriptions-item label="员工数量">{{info.customer.shopCount}}</el-descriptions-item>
          <el-descriptions-item label="正在开展项目" v-if="info.customer.carryProjects">{{info.customer.carryProjects.split('#').join(',')}}</el-descriptions-item>
          <el-descriptions-item label="微信号">{{info.customer.wechat}}</el-descriptions-item>
          <el-descriptions-item label="备注">{{info.customer.note}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==2">
        <Title class="mt20">统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="总订单金额">{{allStatistics.goodsPayMoney}}元</el-descriptions-item>
          <el-descriptions-item label="现金">{{allStatistics.moneyForPayType5}}元</el-descriptions-item>
          <el-descriptions-item label="余额">{{allStatistics.moneyForPayType2}}元</el-descriptions-item>
          <el-descriptions-item label="零售价">{{allStatistics.moneyForPayType1}}元</el-descriptions-item>
          <el-descriptions-item label="学费增额">{{allStatistics.moneyForPayType4}}元</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20">订货订单</Title>
        <el-descriptions title="">
          <el-descriptions-item label="总订单金额">{{orderStatistics.goodsPayMoney}}元</el-descriptions-item>
          <el-descriptions-item label="现金">{{orderStatistics.moneyForPayType5}}元</el-descriptions-item>
          <el-descriptions-item label="余额">{{orderStatistics.moneyForPayType2}}元</el-descriptions-item>
          <el-descriptions-item label="零售价">{{orderStatistics.moneyForPayType1}}元</el-descriptions-item>
          <el-descriptions-item label="学费增额">{{orderStatistics.moneyForPayType4}}元</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20">秒杀金额</Title>
        <el-descriptions title="">
          <el-descriptions-item label="总订单金额">{{seckillStatistics.goodsPayMoney}}元</el-descriptions-item>
          <el-descriptions-item label="现金">{{seckillStatistics.moneyForPayType5}}元</el-descriptions-item>
          <el-descriptions-item label="余额">{{seckillStatistics.moneyForPayType2}}元</el-descriptions-item>
          <el-descriptions-item label="零售价">{{seckillStatistics.moneyForPayType1}}元</el-descriptions-item>
          <el-descriptions-item label="学费增额">{{seckillStatistics.moneyForPayType4}}元</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==3">
        <Title class="mt20">统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="赠送">{{courseInfo.giveCount}}节课</el-descriptions-item>
          <el-descriptions-item label="购买">{{courseInfo.buyCount}}节课</el-descriptions-item>
          <el-descriptions-item label="支付金额">{{courseInfo.totalPayAmount}}元</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==4">
        <Title class="mt20">统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="报名会议">{{meetingInfo.count}}次</el-descriptions-item>
          <el-descriptions-item label="签到会议">{{meetingInfo.signInCount}}次</el-descriptions-item>
          <el-descriptions-item label="未签到">{{meetingInfo.notSignInCount}}次</el-descriptions-item>
          <el-descriptions-item label="报名费用">{{meetingInfo.fee}}元</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==6">
        <el-descriptions title="" :column="12">
          <el-descriptions-item label="余额">{{walletInfo.balance}}</el-descriptions-item>
          <el-descriptions-item label="零售价">{{walletInfo.xiaoduMoney}}</el-descriptions-item>
          <el-descriptions-item label="学费赠送">{{walletInfo.tuition}}</el-descriptions-item>
          <el-descriptions-item label="积分">{{walletInfo.integral}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeName==7">
        <el-timeline reverse v-if="customerList.length">
          <el-timeline-item v-for="(item, index) in customerList" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span>{{item.followUpTitle}}</span>
                <span class="c-8F8E8E">{{item.createdTime.split(' ')[0]}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
              </div>
              <span class="c-8F8E8E">跟进内容：{{item.followUpContent}}</span>
              <div class="flexs mt10" v-if="item.followUpUrl">
                <el-image style="width: 50px; height: 50px;border-radius: 4px;" class="mr10" :src="it" :preview-src-list="[item.followUpUrlList]" v-for="(it,indexs) in item.followUpUrlList" :key="indexs"></el-image>
              </div>
              <div class="mt10 c-8F8E8E">跟进时间：{{item.createdTime}}</div>
              <div class="mt10 c-8F8E8E">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!customerList.length">该客户暂无跟进信息～</Empty>
      </template>
      <template v-if="activeName==8">
        <el-timeline reverse v-if="techList.length">
          <el-timeline-item v-for="(item, index) in techList" :key="index" type="primary">
            <div class="boxs">
              <div class="flexs justify-between mb10">
                <span>{{item.followUpTitle}}</span>
                <span class="c-8F8E8E">{{item.createdTime.split(' ')[0]}} 星期{{setWeek(dayjs(item.createdTime).day())}}</span>
              </div>
              <span class="c-8F8E8E">跟进内容：{{item.followUpContent}}</span>
              <followup-portrait-fields :record="item" />
              <div class="flexs mt10" v-if="item.followUpUrl">
                <el-image style="width: 50px; height: 50px;border-radius: 4px;" class="mr10" :src="it" :preview-src-list="[item.followUpUrlList]" v-for="(it,indexs) in item.followUpUrlList" :key="indexs"></el-image>
              </div>
              <div class="mt10 c-8F8E8E">跟进时间：{{item.createdTime}}</div>
              <div class="mt10 c-8F8E8E">下次跟进时间：{{item.nextFollowUpTime}}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <Empty v-if="!techList.length">该客户暂无跟进信息～</Empty>
      </template>
      <template v-if="activeName==9">
        <Title class="mt20">客户兴趣</Title>
        <echarts-vue :echart-data="echartData" echartName="echarts" />
        <Title class="mt20">互动记录</Title>
        <div class="flexs justify-between">
          <div>互动明细</div>
          <el-date-picker v-model="times" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </div>
        <el-tabs v-model="tabActive" @tab-click="getList">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="商城" name="1"></el-tab-pane>
          <el-tab-pane label="课程" name="2"></el-tab-pane>
        </el-tabs>
        <div class="boxs mb20" style="border-radius: 8px;" v-for="item in browseList" :key="item.id">
          <div class="flexs justify-between mb10">
            <span>{{item.browsingType==1?'浏览商品':'浏览课程'}}</span>
            <span>{{item.createdTime}}</span>
          </div>
          <span class="c-8F8E8E">标题：{{item.headline}}</span>
          <div class="mt10 c-8F8E8E">浏览时长：{{item.browsingTime}}</div>
        </div>
        <Empty v-if="!browseList.length">该客户互动明细～</Empty>
      </template>
    </el-card>
  </div>
</template>

<script>
import echartsVue from './echarts.vue'
import FollowupPortraitFields from '../clientList/followupPortraitFields.vue'
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
import courseSubjectApi from '@/api/course/courseSubject'
import meetingSignUpApi from '@/api/meeting/meetingSignUp'
import technicianInfoApi from '@/api/technical/technicianInfo'
import userApi from '@/api/user'
import dayjs from 'dayjs'
export default {
  props: ['rowId'],
  data() {
    return {
      contractList: [],
      info: {
        customer: {},
        customerUserPO: {},
        customerLevel: {},
        customerCertificates: {},
        line: {},
        technicianInfo: {},
        userWallet: {}
      },
      allStatistics: {
        goodsPayMoney: 0,
        moneyForPayType1: 0,
        moneyForPayType2: 0,
        moneyForPayType4: 0,
        moneyForPayType5: 0
      },
      orderStatistics: {
        goodsPayMoney: 0,
        moneyForPayType1: 0,
        moneyForPayType2: 0,
        moneyForPayType4: 0,
        moneyForPayType5: 0
      },
      seckillStatistics: {
        goodsPayMoney: 0,
        moneyForPayType1: 0,
        moneyForPayType2: 0,
        moneyForPayType4: 0,
        moneyForPayType5: 0
      },
      meetingInfo: {
        count: 0,
        signInCount: 0,
        notSignInCount: 0,
        fee: 0
      },
      walletInfo: {
        balance: 0,
        xiaoduMoney: 0,
        tuition: 0,
        integral: 0
      },
      courseInfo: {
        buyCount: 0,
        giveCount: 0,
        totalPayAmount: 0
      },
      echartData: {},
      listLoading: true,
      list: [],
      customerList: [],
      techList: [],
      browseList: [],
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 3,
        isOpenSea: 0
      },
      standingList: [],
      times: '',
      options: [],
      customerLine: '',
      activeName: '1',
      tabActive: '0',
      stepList: [{
        label: '未参会',
        isActive: true
      },
      {
        label: '已参加推介会',
        isActive: false
      },
      {
        label: '已参加专题课',
        isActive: false
      },
      {
        label: '持续跟进',
        isActive: false
      },
      {
        label: '已报名研修班',
        isActive: false
      },
      ]
    }
  },
  components: { echartsVue, FollowupPortraitFields },
  computed: {
    setWeek() {
      return function (val) {
        switch (val) {
          case 1:
            return "一";
            break;
          case 2:
            return "二";
            break;
          case 3:
            return "三";
            break;
          case 4:
            return "四";
            break;
          case 5:
            return "五";
            break;
          case 6:
            return "六";
            break;
          case 0:
            return "日";
            break;
        }
      }

    }
  },
  async created() {
    this.times = dayjs(new Date()).format("YYYY-MM-DD")
    await this.getBusinessStanding()
    this.getStandingList()
    await this.getDetail()
    this.getOrder()
    this.getCourse()
    this.getMeeting()
    this.getWallet()
    this.getCustomerList()
    this.getTechList()
    this.getBrowse()
    this.getList()
    this.doQueryList({
      pageNo: 1
    })
    // this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串（非数字），直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({ type: 3 }).then(({ data }) => {
        this.standingList = data
        // console.log('客户身份: ',data);
      })
    },
    // 获取浏览统计
    async getBrowse() {
      const { data } = await userApi.getAllCount({ userId: this.info.customer.userId })
      this.echartData = data
      console.log('统计data: ', data);
    },
    // 获取浏览记录列表
    async getList() {
      let obj = {
        userId: this.info.customer.userId,
        pageNo: 1, pageSize: 999
      }
      if (this.tabActive != '0') {
        obj.browsingType = this.tabActive * 1
      }
      obj.startTime = `${this.times} 00:00:00`
      obj.endTime = `${this.times} 23:59:59`
      const { data } = await userApi.getBrowsingHistoryPageList(obj)
      this.browseList = data.list
      // console.log('浏览data: ',data);
    },
    // 业务跟进
    async getCustomerList() {
      const {
        data
      } = await clientListApi.followCustRecord({
        customerId: this.info.customer.id
      })
      // console.log('进度: ',data);
      this.customerList = data.list.map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      })
    },
    // 技术跟进
    async getTechList() {
      const {
        data
      } = await technicianInfoApi.techFollowCustRecord({
        custId: this.info.customer.id
      })
      // console.log('进度: ',data);
      this.techList = data.list.map(item => {
        if (item.followUpUrl) {
          item.followUpUrlList = item.followUpUrl.split(',')
        }
        return item
      })
    },
    // 获取会议统计
    async getMeeting() {
      const { data } = await meetingSignUpApi.getCountFeeByUserInfo({ userInfoId: this.info.customer.id, userType: 20 })
      if (data) {
        for (let key in this.meetingInfo) {
          if (this.meetingInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
            if (data[key]) {
              this.meetingInfo[key] = data[key]
            }
          }
        }
      }
      // this.meetingInfo=data
      console.log('会议: ', data);
    },
    // 课程
    async getCourse() {
      const { data } = await courseSubjectApi.getCourseSubjectStatistics({ userId: this.info.customer.userId })
      for (let key in this.courseInfo) {
        if (this.courseInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
          if (data[key]) {
            this.courseInfo[key] = data[key]
          }
        }
      }
      console.log('课程', data)
    },
    // 获取用户钱包
    async getWallet() {
      const { data } = await clientListApi.getUserWallet({ customerId: this.info.customer.id })
      if (data) {
        for (let key in this.walletInfo) {
          if (this.walletInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
            if (data[key]) {
              this.walletInfo[key] = data[key]
            }
          }
        }
      }
      // console.log('钱包data: ',data);
    },
    // 订单统计
    async getOrder() {
      const { data } = await clientListApi.getStatisticsByTypeGroup(this.info.customer.id)
      if (data.length) {
        data.map(item => {
          for (let key in this.allStatistics) {
            if (this.allStatistics.hasOwnProperty(key)) { // 确保key是对象自身的属性
              if (data[key]) {
                if (!item.type) {
                  this.allStatistics[key] = data[key]
                }
                if (item.type == 1) {
                  this.orderStatistics[key] = data[key]
                }
                if (item.type == 3) {
                  this.seckillStatistics[key] = data[key]
                }
              }
            }
          }
        })
      }
    },
    async getDetail() {
      const {
        data
      } = await clientListApi.fetchById(this.rowId)
      // const {data}=await clientListApi.fetchById(91)
      this.info = data
      this.info.lineList.splice(0, 1)
      if (this.info.contractList && this.info.contractList.length) {
        this.contractList = this.info.contractList.splice(0, 1)
      }
      // console.log('详情: ',this.info.lineList,data);
      this.info.lineList.sort((a, b) => b.clevel - a.clevel)
      let arr = []
      if (this.info.lineList.length) {
        arr = this.info.lineList.map(i => (`${i.name}【${this.options.find(it => it.level == i.clevel).name}】`))
      }
      this.customerLine = arr.join(' - ')
      console.log('详情: ', this.info, data);
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // console.log('this.query: ',this.query,this.dateTime);
      // return
      let query = {
        ...this.query,
        mainId: this.rowId
      }
      if (this.query.timeType && this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.dateTime && this.dateTime.length && !this.query.timeType) {
        this.dateTime = null
      }
      // return
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return clientListApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data111111111: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.options = data
        console.log('客户身份: ', data);
      })
    },
  }

}
</script>

<style lang="scss" scoped>
a:hover {
  color: #60b7dc;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.label-boxs {
  background: #c8ab0e1a;
  padding: 2px 4px;
  border-radius: 2px;
  color: #c8ab0e;
}

.step-box {
  width: 160px;
  height: 44px;
  margin-right: 10px;

  ::v-deep .el-image {
    width: 160px;
    height: 44px;
  }

  div {
    left: 0;
    top: 0;
  }
}

::v-deep.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 14px;
}
</style>
